import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

export class FormValidation {

    public static EMAIL = "Email";
    public static PHONE = "Phone";

      
  public static isValid(formGroup: UntypedFormGroup): boolean {
    if (formGroup && formGroup.valid && formGroup.dirty) {
      return true;
    }
    else {
      this.markAllFormFieldsAsTouched(formGroup);
      return false;
    }
  }

  
  private static markAllFormFieldsAsTouched(formGroup: UntypedFormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.markAllFormFieldsAsTouched(control);
      }
    });
  }
}